import services from './services';
import { util } from 'utils'
import ensurerefund from '../components/ensureRefund/index.vue';
export default {
    mixins: [services],
    components: { ensurerefund },
    data() {
        return {
            loading: false,
            lists: [], //表格内容列表{"CourseId":3,"CourseName":"英语上","SubjectId":1,"SubjectName":"英语","VolumeType":1,"VolumeTypeName":"上册"}
            pageIndex: 1,
            pageSize: 10,
            totalSize: '', //分页总数
            pageSizes: [10, 20, 50], //分页类型
            query: {
                OrderCode: "",
                AgentName: "",
                AreaName: "",
                OrderStatus: "",
                SendStatus: ""
            }, //查询条件
            childorderId: "",
            queryType: [{ "TypeName": "-请选择-", "TypeValue": "-1" }, { "TypeName": "待审核", "TypeValue": "7" }, { "TypeName": "审核通过", "TypeValue": "8" }],
            queryDelivery: [{ "TypeName": "-请选择-", "TypeValue": "-1" }, { "TypeName": "未发货", "TypeValue": "0" }, { "TypeName": "部分发货", "TypeValue": "1" }, { "TypeName": "全部发货", "TypeValue": "2" }],
        }
    },
    methods: {
        resetSearch() {
            this.query = {
                OrderCode: "",
                c_name: "",
                AgentName: "",
                AreaName: "",
                OrderStatus: "",
                SendStatus: ""
            };
            this.req_getList();
        },
        passcheck(item) {
            this.childorderId = item.OrderId;
            this.$nextTick(function() {
                this.$refs.myrefund.getData();
            });
        },
        handleSizeChange: function(val) {
            this.pageSize = val;
            this.req_getList();
        }, //分页选定行
        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.req_getList();
        }, //分页监听dd页面
        handleView: function(index, row) {
            util.redirect(this, '/Order/financialList/ViewOrder?Id=' + row.OrderId + "&from=refund" + "&OrderCode=" + row.OrderCode, true);
        },
    },
    computed: {
        sysSid: function() {
            return this.$store.state.sysSid;
        },
        sysSession: function() {
            return this.$store.state.sysSession;
        },
    },
    created() {
        this.req_getList();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/refund/vm.js